import { render, staticRenderFns } from "./JSelectDefStandard.vue?vue&type=template&id=28076f52&scoped=true&"
import script from "./JSelectDefStandard.vue?vue&type=script&lang=js&"
export * from "./JSelectDefStandard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28076f52",
  null
  
)

export default component.exports